/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components';
import classNames from 'classnames';
import './CheckBox.css';

const CheckBox = ({
  checked,
  onClick,
  dataId,
  disabled,
  className,
  isParameter,
  hoverText,
  ...rest
}) => {
  const ref = React.createRef();

  return (
    <Button onClick={() => ref.current.click()}>
      <div className={classNames('check-box', className)} title={hoverText || null}>
        <input
          {...rest}
          checked={checked}
          onClick={onClick}
          type="checkbox"
          ref={ref}
          readOnly
        />
        <span
          style={
            disabled && isParameter
              ? {
                border: '2px solid var(--grey-3)',
                backgroundColor: 'var(--grey-3)',
              }
              : undefined
          }
        >
          {checked && (
            <i className="material-icons" dataid={dataId}>
              check
            </i>
          )}
        </span>
      </div>
    </Button>
  );
};

CheckBox.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  dataId: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  isParameter: PropTypes.bool,
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/CheckBox/CheckBox.jsx